import { Route, Switch } from 'react-router-dom';
import { ROUTES } from '../../constants/routes';
import { CompanyPromotions } from './pages/CompanyPromotions';
import { CreateCompanyPromotion } from './pages/CreateCompanyPromotion';
import { EditCompanyPromotion } from './pages/EditCompanyPromotion';
import { DetailCompanyPromotion } from './pages/DetailCompanyPromotion';

export const CompanyPromotionsRoutes = () => {
  return (
    <Switch>
      <Route path={ROUTES.COMPANY_PROMOTIONS} exact={true} component={CompanyPromotions} />
      <Route path={ROUTES.COMPANY_PROMOTIONS_CREATE} component={CreateCompanyPromotion} />
      <Route path={ROUTES.COMPANY_PROMOTIONS_EDIT} component={EditCompanyPromotion} />
      <Route path={ROUTES.COMPANY_PROMOTIONS_COPY} component={CreateCompanyPromotion} />
      <Route path={ROUTES.COMPANY_PROMOTIONS_DETAIL} component={DetailCompanyPromotion} />
    </Switch>
  );
};
